<template>
  <span id="floatAlert">
    <span
      v-if="login && userNotificationsCount && userNotificationsCount.smsCount"
    >
      <!-- :activator="userNotificationsCount.smsCount" -->
      <AdvertisementBanner
        :activator="notsDialogSMS"
        :ad="{
          dispatch: {
            advertisement: {
              title: userNotificationsCount.smsCount,
            },
          },
        }"
        @closeDial="closeNotsCount()"
        type="smsLeft"
      />
    </span>
    <span
      v-if="
        login && userNotificationsCount && userNotificationsCount.whatsappCount
      "
    >
      <AdvertisementBanner
        :activator="notsDialogWhatsapp"
        :ad="{
          dispatch: {
            advertisement: {
              title: userNotificationsCount.whatsappCount,
            },
          },
        }"
        @closeDial="closeNotsCount()"
        type="whatsappLeft"
      />
    </span>
  </span>
</template>
<script>
import AdvertisementBanner from "@/components/general/AdvertisementBanner.vue";
export default {
  name: "NotsCount",
  components: { AdvertisementBanner },
  data() {
    return {
      notsDialogSMS: false,
      notsDialogWhatsapp: false,
      exceedsLimitSMS: null,
      exceedsLimitWhatsapp: null,
    };
  },
  computed: {
    login() {
      return this.$store.getters["user/valid"];
    },
    userNotificationsCount() {
      let user = JSON.parse(JSON.stringify(this.$store.getters["user/user"]));
      if (
        !user ||
        !user.email ||
        !user.notification_privileges ||
        !user.notifications_used
      ) {
        return null;
      }
      const totalSms = user.notification_privileges.sms ?? 0;
      const usedSms = user.notifications_used.sms ?? 0;
      const totalWhatsapp = user.notification_privileges.whatsapp ?? 0;
      const usedWhatsapp = user.notifications_used.whatsapp ?? 0;
      const remainingSms = Math.max(totalSms - usedSms, 0);
      const remainingWhatsapp = Math.max(totalWhatsapp - usedWhatsapp, 0);
      const pctLeftWhatsapp =
        totalWhatsapp > 0 ? (remainingWhatsapp / totalWhatsapp) * 100 : 0;
      const pctLeftSms = totalSms > 0 ? (remainingSms / totalSms) * 100 : 0;
      let smsCount = null;
      let whatsappCount = null;
      let exceedsLimitSMS = null;
      let exceedsLimitWhatsapp = null;
      if (
        user.notification_privileges.sms != "0" &&
        user.notification_privileges.sms !== "-1"
      ) {
        switch (true) {
          case user.notification_privileges.sms == "250":
            if (pctLeftSms <= 20 && pctLeftSms > 10) {
              smsCount =
                this.$t("used") + " 80% " + this.$t("from-sms-package80");
              exceedsLimitSMS = "80";
            } else if (pctLeftSms <= 10 && pctLeftSms > 5) {
              smsCount =
                this.$t("used") + " 90% " + this.$t("from-sms-package90");
              exceedsLimitSMS = "90";
            } else if (pctLeftSms == 0) {
              smsCount =
                this.$t("used") + " 100% " + this.$t("from-sms-package100");
              exceedsLimitSMS = "100";
            }
            break;

          case user.notification_privileges.sms == "500":
            if (pctLeftSms <= 20 && pctLeftSms > 10) {
              smsCount =
                this.$t("used") + " 80% " + this.$t("from-sms-package80");
              exceedsLimitSMS = "80";
            } else if (pctLeftSms <= 10 && pctLeftSms > 5) {
              smsCount =
                this.$t("used") + " 90% " + this.$t("from-sms-package90");
              exceedsLimitSMS = "90";
            } else if (pctLeftSms == 0) {
              smsCount =
                this.$t("used") + " 100% " + this.$t("from-sms-package100");
              exceedsLimitSMS = "100";
            }
            break;

          case user.notification_privileges.sms == "1000":
            if (pctLeftSms <= 20 && pctLeftSms > 10) {
              smsCount =
                this.$t("used") + " 80% " + this.$t("from-sms-package80");
              exceedsLimitSMS = "80";
            } else if (pctLeftSms <= 10 && pctLeftSms > 5) {
              smsCount =
                this.$t("used") + " 90% " + this.$t("from-sms-package90");
              exceedsLimitSMS = "90";
            } else if (pctLeftSms == 0) {
              smsCount =
                this.$t("used") + " 100% " + this.$t("from-sms-package100");
              exceedsLimitSMS = "100";
            }
            break;
          default:
            break;
        }
      }

      if (
        user.notification_privileges.whatsapp != "0" &&
        user.notification_privileges.whatsapp != "-1"
      ) {
        switch (true) {
          case user.notification_privileges.whatsapp == "250":
            if (pctLeftWhatsapp <= 20 && pctLeftWhatsapp > 10) {
              whatsappCount =
                this.$t("used") + " 80% " + this.$t("from-whatsapp-package80");
              exceedsLimitWhatsapp = "80";
            } else if (pctLeftWhatsapp <= 10 && pctLeftWhatsapp > 5) {
              whatsappCount =
                this.$t("used") + " 90% " + this.$t("from-whatsapp-package90");
              exceedsLimitWhatsapp = "90";
            } else if (pctLeftWhatsapp == 0) {
              whatsappCount =
                this.$t("used") +
                " 100% " +
                this.$t("from-whatsapp-package100");
              exceedsLimitWhatsapp = "100";
            }
            break;

          case user.notification_privileges.whatsapp == "500":
            if (pctLeftWhatsapp <= 20 && pctLeftWhatsapp > 10) {
              whatsappCount =
                this.$t("used") + " 80% " + this.$t("from-whatsapp-package80");
              exceedsLimitWhatsapp = "80";
            } else if (pctLeftWhatsapp <= 10 && pctLeftWhatsapp > 5) {
              whatsappCount =
                this.$t("used") + " 90% " + this.$t("from-whatsapp-package90");
              exceedsLimitWhatsapp = "90";
            } else if (pctLeftWhatsapp == 0) {
              whatsappCount =
                this.$t("used") +
                " 100% " +
                this.$t("from-whatsapp-package100");
              exceedsLimitWhatsapp = "100";
            }
            break;

          case user.notification_privileges.whatsapp == "1000":
            if (pctLeftWhatsapp <= 20 && pctLeftWhatsapp > 10) {
              whatsappCount =
                this.$t("used") + " 80% " + this.$t("from-whatsapp-package80");
              exceedsLimitWhatsapp = "80";
            } else if (pctLeftWhatsapp <= 10 && pctLeftWhatsapp > 5) {
              whatsappCount =
                this.$t("used") + " 90% " + this.$t("from-whatsapp-package90");
              exceedsLimitWhatsapp = "90";
            } else if (pctLeftWhatsapp == 0) {
              whatsappCount =
                this.$t("used") +
                " 100% " +
                this.$t("from-whatsapp-package100");
              exceedsLimitWhatsapp = "100";
            }
            break;
          default:
            break;
        }
        //
      }
      return {
        smsCount: smsCount,
        smsExceeds: exceedsLimitSMS,
        whatsappCount: whatsappCount,
        whatsappExceeds: exceedsLimitWhatsapp,
      };
    },
  },
  watch: {
    userNotificationsCount: {
      handler() {
        setTimeout(() => {
          if (!this.userNotificationsCount) return;
          if (this.userNotificationsCount.smsExceeds) {
            this.exceedsLimitSMS = this.userNotificationsCount.smsExceeds;
          }
          if (this.userNotificationsCount.whatsappExceeds) {
            this.exceedsLimitWhatsapp =
              this.userNotificationsCount.whatsappExceeds;
          }
          let smsCountStorage = localStorage.getItem(
            "smsCount" + this.exceedsLimitSMS
          );
          let whatsappCountStorage = localStorage.getItem(
            "whatsappCount" + this.exceedsLimitWhatsapp
          );
          // console.log(
          //   this.exceedsLimitWhatsapp,
          //   this.userNotificationsCount.whatsappCount.includes(
          //     whatsappCountStorage
          //   ),
          //   this.userNotificationsCount
          // );
          if (
            whatsappCountStorage &&
            this.userNotificationsCount.whatsappCount &&
            !this.userNotificationsCount.whatsappCount.includes(
              whatsappCountStorage
            )
          ) {
            this.notsDialogWhatsapp = true;
          }
          if (
            smsCountStorage &&
            this.userNotificationsCount.smsCount &&
            !this.userNotificationsCount.smsCount.includes(smsCountStorage)
          ) {
            this.notsDialogSMS = true;
          }
          if (!whatsappCountStorage) {
            this.notsDialogWhatsapp = true;
          }
          if (!smsCountStorage) {
            this.notsDialogSMS = true;
          }
        }, 5000);
      },
      deep: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
    closeNotsCount() {
      this.notsDialogSMS = false;
      this.notsDialogWhatsapp = false;
      this.exceedsLimitSMS
        ? localStorage.setItem(
            "smsCount" + this.exceedsLimitSMS,
            this.exceedsLimitSMS
          )
        : localStorage.setItem(
            "whatsappCount" + this.exceedsLimitWhatsapp,
            this.exceedsLimitWhatsapp
          );
    },
  },
};
</script>
<style lang="scss" scoped></style>
